import { useQuery } from "@tanstack/react-query";
import type { City } from "@lezz/shared";
import { apiFetch } from "@/shared/lib/bff/client";

export const cityKeys = {
  all: ["cities"] as const,
  byState: (state: string) => [...cityKeys.all, "byState", state] as const,
};

export async function fetchCitiesByState(state: string): Promise<City[]> {
  return apiFetch<City[]>(
    `/api/location/cities?state=${encodeURIComponent(state)}`
  );
}

export function useCitiesByState(state: string | null) {
  return useQuery({
    queryKey: cityKeys.byState(state!),
    queryFn: () => fetchCitiesByState(state!),
    enabled: !!state,
  });
}
